import React, {Component} from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import TablePaginationActions from "./TablePaginationActions";
import Paper from "@material-ui/core/es/Paper";
import Table from "@material-ui/core/es/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/es/TableRow";
import TableCell from "@material-ui/core/es/TableCell";
import TableFooter from "@material-ui/core/TableFooter";
import TablePagination from "@material-ui/core/es/TablePagination";
import TableHead from "@material-ui/core/TableHead";
import Grow from "@material-ui/core/es/Grow";
import LabelAndText from "../../../components/common/LabelAndText";
import List from "@material-ui/core/es/List";
import ListSubheader from "@material-ui/core/es/ListSubheader";
import ListItem from "@material-ui/core/es/ListItem";
import ListItemText from "@material-ui/core/es/ListItemText";
import Grid from "@material-ui/core/es/Grid";
import * as classnames from "classnames";

class DaInfoList extends Component {

    state = {
        page: 0,
        rowsPerPage: 5,
    };

    handleChangePage = (event, page) => this.setState({page});

    handleChangeRowsPerPage = event => this.setState({rowsPerPage: event.target.value});

    render() {
        const {classes, account, timeout, content} = this.props;
        const {rowsPerPage, page} = this.state;
        const {daInfo, index, userInfo} = account.pii;
        const data = content || daInfo;
        if (!data && !index && !userInfo) {
            return null
        }

        // const emptyRows = data ? rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage) : undefined;

        return (
            // <Grow in>
                <Paper className={classes.pageContainer}>
                    <h2 className={classes.title}>Account Info</h2>
                    {data &&
                    <div className={classnames(classes.tableWrapper, classes.infoTable)}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Name</TableCell>
                                    <TableCell>Description</TableCell>
                                    <TableCell>Phone</TableCell>
                                    <TableCell>Phone Manufacturer</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((n, i) => {
                                    return (
                                        <TableRow key={n.model + n.description + n.dManufacturer + i}>
                                            <TableCell className={classes.tableCell}>{n.displayName}</TableCell>
                                            <TableCell className={classes.tableCell}>{n.description}</TableCell>
                                            <TableCell className={classes.tableCell}>{n.model}</TableCell>
                                            <TableCell className={classes.tableCell}>{n.dManufacturer}</TableCell>
                                        </TableRow>
                                    );
                                })}
                                {/*{emptyRows > 0 && (*/}
                                {/*<TableRow style={{height: 48 * emptyRows}}>*/}
                                {/*<TableCell colSpan={6}/>*/}
                                {/*</TableRow>*/}
                                {/*)}*/}
                            </TableBody>
                            {data.length > 5 && <TableFooter>
                                <TableRow>
                                    <TablePagination
                                        colSpan={4}
                                        count={data.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        rowsPerPageOptions={[5]}
                                        onChangePage={this.handleChangePage}
                                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                        Actions={TablePaginationActions}
                                    />
                                </TableRow>
                            </TableFooter>}
                        </Table>
                    </div>}
                    <Grid container className={classes.additionalInfo}>
                        {index &&
                        <Grid item xs={12} md={6}>
                            <LabelAndText label="Push Services" content={index.isCredentialsExist} autoSize />
                        </Grid>}

                        {userInfo && userInfo.length > 0 &&
                        <Grid item xs={12} md={6}>
                            <List className={classes.contactsList} subheader={<li/>}>
                                <ListSubheader>Phone Numbers</ListSubheader>
                                {userInfo.map(({phone}, index) => (
                                    <ListItem key={phone}>
                                        <ListItemText primary={phone}/>
                                    </ListItem>
                                ))}
                            </List>
                        </Grid>}
                    </Grid>
                </Paper>
            // </Grow>
        );
    }
}

function mapStateToProps({account}) {
    return ({account})
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(DaInfoList);



// WEBPACK FOOTER //
// ./src/containers/delete-account/components/DaInfoTable.js